import jkAvatar from './img/authors/jk.jpeg'

export const jk = {
  name: 'JK Baseer',
  twitter: 'jkbaseer',
  avatar: jkAvatar,
}
